<template>
  <div>
    <div class="tabs">
      <ul>
        <li v-for="tab in navigationTabs"
          :key="tab.label"
          :class="{ 'active-tab': isActive(tab.name) }">
          <a @click.stop="navigateToRoute({ name: tab.name })">
            <localized-label>{{tab.label}}</localized-label>
          </a>
        </li>
      </ul>
    </div>
    <div>
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { concat, has } from 'lodash';

export default {
  name: 'RouterTabs',
  props: {
    tabs: {
      type: Array,
      default() {
        return [
          { name: 'Tickets', label: 'tabsTicketsTitle' },
          { name: 'Rounds', label: 'tabsRoundsTitle' },
        ];
      },
    },
  },
  data() {
    return {
      activeTab: null,
      navigationTabs: this.tabs,
    };
  },
  computed: {
    ...mapGetters([
      'route',
      'wheel',
    ]),
  },
  watch: {
    wheel(value) {
      if (has(value.definition, 'jackpot') && value.definition.jackpot.enabled) {
        const jackpots = { name: 'Jackpots', label: 'tabsJackpotsTitle' };
        this.navigationTabs = concat(this.navigationTabs, jackpots);
      }
    },
  },
  mounted() {
    this.activeTab = this.route.name;
  },
  methods: {
    isActive(tab) {
      return this.activeTab === tab;
    },
    navigateToRoute(route) {
      this.activeTab = route.name;
      this.$router.push(route);
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs {
  height: 43px;
  background-color: #2e3743;
  ul {
    display: flex;
    list-style-type: none;
    padding: 0;
    li {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 68px;
      height: 43px;
      border-top: 3px solid transparent;
      a {
        display: block;
        color: #808b9c;
        font-size: 14px;
      }
    }
  }
}

.active-tab {
  border-color:#009aff !important;
  a {
    color: #fff !important;
  }
}
</style>
